import { GlobalState } from '../../store/types';

export const getVariables = (state: GlobalState) => state.variables;
export const getLastPatientDuplicateDateSelector = (state: GlobalState) =>
  state.variables.lastPatientDuplicateDate;
